<template>
  <div class="word-upload">
    <div v-if="fileUrl" class="file-row">
      <a :href="fileUrl" target="_blank" rel="noopener noreferrer" class="file-link">
        {{ fileName }}
      </a>
      <a-button type="link" @click="handleRemove">删除</a-button>
    </div>
    <a-upload
      accept=".pdf,.png,.jpg,.jpeg"
      :beforeUpload="beforeUpload"
      :customRequest="customRequest"
      :showUploadList="false"
    >
      <div v-if="!fileUrl">
        <a-button>
          <a-icon type="upload" />
          上传 PDF/PNG/JPG
        </a-button>
      </div>
    </a-upload>
  </div>
</template>

<script>
import {
  DIRECT_UPLOAD_PURPOSE_COMMITMENT,
  uploadFileDirectToOss,
} from "@/utils/directOssUpload";

const COMMITMENT_NAME_RE = /\.(pdf|png|jpe?g)$/i;
const PDF_TYPES = ["application/pdf"];
const PNG_TYPES = ["image/png", "image/x-png"];
const JPG_TYPES = ["image/jpeg", "image/jpg", "image/pjpeg"];

export default {
  name: "WordUpload",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    fileUrl() {
      return String(this.value || "").trim();
    },
    fileName() {
      if (!this.fileUrl) {
        return "";
      }
      const cleanUrl = this.fileUrl.split("?")[0];
      const segments = cleanUrl.split("/");
      return decodeURIComponent(segments[segments.length - 1] || "原创承诺书.pdf");
    },
  },
  methods: {
    resolveUploadUrl(response) {
      const payload = response && response.data ? response.data : response;
      if (!payload) return "";
      if (typeof payload === "string") return payload.trim();
      if (typeof payload.link === "string" && payload.link.trim()) return payload.link.trim();
      if (typeof payload.url === "string" && payload.url.trim()) return payload.url.trim();
      if (payload.data && typeof payload.data === "object") {
        if (typeof payload.data.link === "string" && payload.data.link.trim()) {
          return payload.data.link.trim();
        }
        if (typeof payload.data.url === "string" && payload.data.url.trim()) {
          return payload.data.url.trim();
        }
      }
      return "";
    },
    beforeUpload(file) {
      const isPdfOrPngOrJpg =
        COMMITMENT_NAME_RE.test(file.name) ||
        PDF_TYPES.includes(file.type) ||
        PNG_TYPES.includes(file.type) ||
        JPG_TYPES.includes(file.type);
      if (!isPdfOrPngOrJpg) {
        this.$message.error("原创承诺书仅支持 PDF、PNG 或 JPG 文件");
        return false;
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error("原创承诺书文件大小不能超过 5MB");
        return false;
      }
      return true;
    },
    async customRequest(options) {
      const { file, onProgress, onSuccess, onError } = options;
      try {
        const result = await uploadFileDirectToOss(file, {
          onProgress,
          purpose: DIRECT_UPLOAD_PURPOSE_COMMITMENT,
        });
        const fileUrl = this.resolveUploadUrl(result);
        this.$emit("input", fileUrl);
        if (typeof onProgress === "function") {
          onProgress({ percent: 100 });
        }
        if (typeof onSuccess === "function") {
          onSuccess({ url: fileUrl }, file);
        }
      } catch (error) {
        this.$message.error(
          (error && error.response && error.response.data && error.response.data.msg) ||
            error.message ||
            "原创承诺书上传失败"
        );
        if (typeof onError === "function") {
          onError(error);
        }
      }
    },
    handleRemove() {
      this.$emit("input", "");
    },
  },
};
</script>

<style scoped>
.word-upload {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.file-link {
  color: #e28947;
  word-break: break-all;
}
</style>
